import { useSelector } from "react-redux";
import AppSettingsSidebarIcon from "../icons/AppSettingsSidebarIcon";
import AdminOptionsIcon from "../icons/AdminOptionsIcon";
import CustomerSupportSidebarIcon from "../icons/CustomerSupportSidebarIcon";
import EmployeesIcon from "../icons/EmployeesIcon";
import LogsIcon from "../icons/LogsIcon";
import RegionSidebarIcon from "../icons/RegionSidebarIcon";
import SocialMediaSidebarIcon from "../icons/SocialMediaSidebarIcon";
import SquadsSidebarIcon from "../icons/SquadsSidebarIcon";
import TimelinesSidebarIcon from "../icons/TimelinesSidebarIcon";
import TournamentCommentsSidebarIcon from "../icons/TournamentCommentsSidebarIcon";
import TournamentSidebarIcon from "../icons/TournamentSidebarIcon";
import TournamentTablesIcon from "../icons/TournamentTablesIcon";
import UsersSidebarIcon from "../icons/UsersSidebarIcon";
import PageLink from "../pageLink/PageLink";
import styles from "./sideBar.module.css";

const SideBar = () => {
  const { rolePermissions } = useSelector((state) => state.user);

  return (
    <div className={styles.container}>
      {rolePermissions.includes("overview") && (
        <div className={styles.linkWrapper}>
          <PageLink icon={AdminOptionsIcon} destination={"/dashboard/admin-options"}>
            خيارات الادمن
          </PageLink>
        </div>
      )}
      {rolePermissions.includes("view-logs") && (
        <div className={styles.linkWrapper}>
          <PageLink icon={LogsIcon} destination={"/dashboard/logs"}>
            سجل العمليات
          </PageLink>
        </div>
      )}
      {rolePermissions.includes("control-admins") && (
        <div className={styles.linkWrapper}>
          <PageLink icon={EmployeesIcon} destination={"/dashboard/emlpoyees"}>
            ادارة الموظفين
          </PageLink>
        </div>
      )}
      {rolePermissions.includes("control-tournaments") && (
        <div className={styles.linkWrapper}>
          <PageLink
            icon={TournamentSidebarIcon}
            destination={"/dashboard/tournaments"}
          >
            ادارة البطولات
          </PageLink>
        </div>
      )}
      {rolePermissions.includes("control-regions") && (
        <div className={styles.linkWrapper}>
          <PageLink icon={RegionSidebarIcon} destination={"/dashboard/regions"}>
            ادارة المناطق
          </PageLink>
        </div>
      )}
      {rolePermissions.includes("control-users") && (
        <div className={styles.linkWrapper}>
          <PageLink icon={UsersSidebarIcon} destination={"/dashboard/users"}>
            ادارة اللاعبين
          </PageLink>
        </div>
      )}
      {rolePermissions.includes("control-squads") && (
        <div className={styles.linkWrapper}>
          <PageLink icon={SquadsSidebarIcon} destination={"/dashboard/squads"}>
            ادارة السكوادات
          </PageLink>
        </div>
      )}
      {rolePermissions.includes("control-tables") && (
        <div className={styles.linkWrapper}>
          <PageLink icon={TimelinesSidebarIcon} destination={"/dashboard/timelines"}>
            الجداول الزمنية
          </PageLink>
        </div>
      )}
      {rolePermissions.includes("control-tables") && (
        <div className={styles.linkWrapper}>
          <PageLink
            icon={TournamentTablesIcon}
            destination={"/dashboard/tournament-tables"}
          >
            جداول البطولات
          </PageLink>
        </div>
      )}
      {rolePermissions.includes("control-chat") && (
        <div className={styles.linkWrapper}>
          <PageLink
            icon={CustomerSupportSidebarIcon}
            destination={"/dashboard/customer-support"}
          >
            شات المستخدمين
          </PageLink>
        </div>
      )}
      {rolePermissions.includes("control-tournament-comments") && (
        <div className={styles.linkWrapper}>
          <PageLink
            icon={TournamentCommentsSidebarIcon}
            destination={"/dashboard/tournaments-comments"}
          >
            تعليقات البطولات
          </PageLink>
        </div>
      )}
      {rolePermissions.includes("control-socialmedia") && (
        <div className={styles.linkWrapper}>
          <PageLink
            icon={SocialMediaSidebarIcon}
            destination={"/dashboard/social-media"}
          >
            السوشال ميديا
          </PageLink>
        </div>
      )}
      {rolePermissions.includes("control-appVersion") && (
        <div className={styles.linkWrapper}>
          <PageLink
            icon={AppSettingsSidebarIcon}
            destination={"/dashboard/app-settings"}
          >
            التطبيق
          </PageLink>
        </div>
      )}
    </div>
  );
};

export default SideBar;
